import { Interpolation } from "@emotion/core";
import { grid } from "../../../../design-tokens/grid";
import { Colors } from "../../../../design-tokens/colors";
import { DarkTheme, Device } from "../../../../design-tokens/media-queries";
import { Border } from "../../../../design-tokens/borders";

const root: Interpolation = {
  backgroundColor: Colors.LightGrey,
  padding: grid(1.5),
  borderRadius: Border.Radius,
  marginBottom: grid(3),

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },

  [Device.DesktopTablet]: {
    padding: grid(2),
    marginBottom: grid(4),
  },
};

const progressBar: Interpolation = {
  display: "flex",
  justifyContent: "flex-end",
  height: grid(2),
  backgroundColor: Colors.Pink,
  borderRadius: grid(2),
  marginBottom: grid(1),
  overflow: "hidden",
};

const progressLabel: Interpolation = {
  display: "flex",
  justifyContent: "space-between",
  fontSize: "12px",

  [Device.MobilePortXs]: {
    fontSize: "11px",
  },
};

const legend: Interpolation = {
  display: "flex",
  alignItems: "center",
};

const indicator: Interpolation = {
  width: 7,
  height: 7,
  marginRight: grid(0.5),
  borderRadius: "50%",

  [Device.DesktopTablet]: {
    width: 10,
    height: 10,
    marginRight: grid(1),
  },
};

const styles = {
  root,
  progressBar,
  progressLabel,
  legend,
  indicator,
};

export default styles;
